// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import Dropdown from 'common/components/ui/Dropdown';
import { type MetricType } from '../../../domain/DashboardData';

export const DROPDOWN_ID = 'dashboard-metric-selector';

const Wrapper = styled.div`
  width: 189px;
`;

interface Props {
  onChange: (metricType: MetricType) => void;
  value: MetricType;
  t: any;
}

export function DashboardMetricTypeSelector(props: Props) {
  const { onChange, value, t } = props;
  const items = [
    { label: t('reach'), value: 'reach' },
    { label: t('listeningTime'), value: 'listeningTime' },
  ];

  return (
    <Wrapper>
      <Dropdown
        defaultValue={value}
        id={DROPDOWN_ID}
        items={items}
        onChange={onChange}
      />
    </Wrapper>
  );
}

export default translate('dashboard')(DashboardMetricTypeSelector);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/DashboardMetricTypeSelector.js